import { useEffect, useState } from 'react';
import { useFileContext, Video } from '../../useFileContext';
import styles from './VideoPage.module.css';
import { useParams } from 'react-router-dom';

const VideoPage = () => {
  const { videos, setCategoria } = useFileContext();
  const [video, setVideo] = useState<Video | undefined>();
  const { videoParam } = useParams();
  const definirVideo = () => {
    const videoFiltrado = videos?.filter(
      (video) =>
        video.titulo === decodeURIComponent(videoParam ? videoParam : ''),
    );
    if (videoFiltrado) setVideo(videoFiltrado[0]);
  };

  useEffect(() => {
    setCategoria(undefined);
    definirVideo();
  }, []);

  return (
    <section className={styles.containerMain}>
      <iframe
        className={styles.video}
        src={`https://www.youtube.com/embed/${video?.url}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={video?.titulo}
      ></iframe>
      <div className={styles.containerDados}>
        <h1>{video?.titulo?.toUpperCase()}</h1>
        <p>{video?.descricao}</p>
      </div>
    </section>
  );
};

export default VideoPage;
